import React from 'react';
import { auth } from '../firebaseConfig';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

const Login = () => {
  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/drive');
    try {
      const result = await signInWithPopup(auth, provider);
      // Salva l'access token di Google per usarlo con il Picker API
      const credential = GoogleAuthProvider.credentialFromResult(result);
      if (credential?.accessToken) {
        sessionStorage.setItem('googleAccessToken', credential.accessToken);
      }
    } catch (error) {
      console.error("Errore durante il login con Google:", error);
      alert("Impossibile effettuare il login. Riprova.");
    }
  };

  return (
    <div className="text-center p-10 bg-white rounded-lg shadow-md">
      <h1 className="text-3xl font-bold mb-4">Benvenuto!</h1>
      <p className="mb-6 text-gray-600">Accedi con il tuo account Google per creare e gestire le tue liste di cose da fare.</p>
      <button
        onClick={handleGoogleLogin}
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg transition duration-300"
      >
        Accedi con Google
      </button>
    </div>
  );
};

export default Login;